import React from "react";
import {Offcanvas} from "react-bootstrap";
import {useAppDispatch, useAppSelector} from "../../../app/store";
import {closePreview} from "../../../app/slices/offCanvas/previewOffCanvas";

export const PreviewOffCanvas = () => {
    const dispatch = useAppDispatch();
    const {url, isOpen} = useAppSelector((state) => state.previewOffCanvas);

    const handleClose = () => {
        dispatch(closePreview());
    }

    return (
        <Offcanvas className='preview-offcanvas' show={isOpen} placement='start' onHide={handleClose}>
            <Offcanvas.Header closeButton>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <iframe referrerPolicy="strict-origin" src={url} title="Preview" width="100%" height="90%" allowFullScreen/>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default PreviewOffCanvas;